import localStrings from "../../localStrings";
import PageWithTitle from "../../components/pages/pageWithTitle";
import React from "react";
import {executeMutationUtil} from "../../utils/gqlUtil";
import {
    addDataChartBoardItemToCache,
    bulkDeleteChartBoardItemMutation,
    createChartBoardItemMutation,
    deletehartBoardItemFromCache,
    updateChartBoardItemMutation
} from "../../gql/chartBoardItemGql";
import enqueueSnackbarWithSound from "../../utils/SnackBarWithSound";
import toast from "react-hot-toast";
import TurnOverSpark from "../MainCharts/TurnOverSpark";
import SeatsSpark from "../MainCharts/SeatsSpark";
import OrdersSpark from "../MainCharts/OrdersSpark";
import AverageTicketSpark from "../MainCharts/AverageTicketSpark";
import DiscountsSpark from "../MainCharts/DiscountsSpark";
import TopTenProducts from "../MainCharts/TopTenProducts";
import {Grid, useMediaQuery} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import SumupTotalStaffYesterday from "./SumupTotalStaffYesterday";
import SumupTurnover from "./SumupTurnover";

export  async function addChartToBoard(item, setAddGraphOpened, userInDb,
                                       enqueueSnackbarWithSound, chartBoardsItems, setChartBoardsItems, boardId) {
    setAddGraphOpened(false)
    const created = await executeMutationUtil(createChartBoardItemMutation(userInDb.id, {
        chartImplementationId: item.id,
        boardId: boardId,
    }))
    await addDataChartBoardItemToCache(userInDb.id, [created.data?.addChartBoardItem]);

    enqueueSnackbarWithSound(toast, null, null,
        localStrings.notif.chartBoardItemAdded);

    setChartBoardsItems([
        ...chartBoardsItems,
        created.data?.addChartBoardItem
    ])
}

export async function addDataGridToBoard(item, setAddGraphOpened, userInDb,
                                         enqueueSnackbarWithSound, chartBoardsItems, setChartBoardsItems, boardId) {
    setAddGraphOpened(false)
    const created = await executeMutationUtil(createChartBoardItemMutation(userInDb.id, {
        dataGridImplementationId: item.id,
        boardId: boardId,
    }))
    await addDataChartBoardItemToCache(userInDb.id, [created.data?.addChartBoardItem]);

    enqueueSnackbarWithSound(toast, null, null,
        localStrings.notif.chartBoardItemAdded);

    setChartBoardsItems([
        ...chartBoardsItems,
        created.data?.addChartBoardItem
    ])
}

export function filterBoards(chartBoardItems, boardId) {
    return (chartBoardItems || []).filter(chartBoardItem => chartBoardItem.boardId == boardId);
}

export async function updateChartBoardsItem(item, userInDb, chartBoardsItems, setChartBoardsItems) {
    const res = await executeMutationUtil((updateChartBoardItemMutation(userInDb.id, item)));

    const updatedItems = [...chartBoardsItems]; // Create a shallow copy of the array
    const index = updatedItems.findIndex((chartBoardItem) => chartBoardItem.id === item.id);

    if (index !== -1) {
        updatedItems.splice(index, 1, res.data?.updateChartBoardItem); // Replace the item at the found index
    }

    setChartBoardsItems(updatedItems);
}

export async function removeChartBoardItem(item, userInDb, chartBoardsItems, setChartBoardsItems) {
    const res = await executeMutationUtil((bulkDeleteChartBoardItemMutation(userInDb.id, [item.id])));
    await deletehartBoardItemFromCache(userInDb.id, [item.id]);
    setChartBoardsItems(chartBoardsItems.filter((chartBoardItem) => chartBoardItem.id !== item.id));
    enqueueSnackbarWithSound(toast, null, null,
        localStrings.notif.chartBoardItemRemoved);
}

const HomePage = () => {
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
    // Force graph mode for testing - change to md or sm for lower screen sizes
    const forceGraphMode = useMediaQuery((theme) => theme.breakpoints.up("md"));

    const components = [
        <TurnOverSpark modeGraph={forceGraphMode} />,
        <SeatsSpark />,
        <OrdersSpark />,
        <AverageTicketSpark />,
        <DiscountsSpark />
    ];

    const isOdd = components.length % 2 !== 0;

    return (
        <PageWithTitle title={localStrings.mainDashboard}>
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
                {/* Graphiques standards */}
                {components.map((Component, i) => (
                    <Grid
                        item
                        key={i}
                        xs={isOdd && i === components.length - 1 ? 12 : 6}
                        lg={6}
                    >
                        {Component}
                    </Grid>
                ))}

                {/* Derniers graphiques : top produits */}
                <Grid item xs={12} lg={12}>
                    <TopTenProducts />
                </Grid>
                <Grid item xs={12} lg={12}>
                    <TopTenProducts typeQuantity />
                </Grid>
            </Grid>
        </PageWithTitle>
    );
};

export default HomePage;
